// extracted by mini-css-extract-plugin
export default {"singlecolorgrey":"var(--icon)","singlecolorpurple":"var(--dropdown-checked-icon-color)","spinner-line-fade-quick":"Spinner_spinner-line-fade-quick__1y2Dd"};